/*
export const someGetter = (state) => {}
 */
import { date } from 'quasar'

export default {
  certificateList
}

function certificateList (state, getters, rootState) {
  return state.list.map(certificate => {
    certificate.DATE_CREATED = (certificate.DATE_CREATED) ? date.formatDate(certificate.DATE_CREATED, rootState.shared.formats.date) : null
    return certificate
  })
}
